<template>
  <div class="foot clear_fd">
    <span class="foot_left_img"></span>
    <div class="foot_right">
      <div class="mt45"> <span class="mr40 posr" @click="childNav('about')">关于我们</span> <span class="posr" @click="childNav('relation')">联系我们</span> </div>
      <div v-if="!isHnls" class="mt30">Copyright© 2014-2024 量势（深圳）控股有限公司 联系电话：0755-86951353</div>
      <div v-if="!isHnls" class="mt5"><a class="beian_mark" target="_blank" href="//beian.miit.gov.cn/">粤ICP备 17123349 号</a></div>
      <div v-if="isHnls" class="mt30">Copyright© 2014-2024 量势新能源科技（三亚）有限公司 联系电话：18084694993</div>
      <div v-if="isHnls" class="mt5"><a class="beian_mark" target="_blank" href="//beian.miit.gov.cn/">琼ICP备2023009628号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      isHnls: false,
    }
  },
  methods:{
    childNav: function(path) {
      this.$emit("childNav", path);
    },
  },
  created() {
    if(location.origin == 'https://www.charge-i.cn'){//海南量势

      this.isHnls = true
    }else{//量势
      this.isHnls = false
    }
  }
}
</script>

<style scoped>
.foot{
  background-color: #333333;
  padding: 0 20%;
}
/* .foot_left {
  width: 40%;
  text-align: center;
  float: left;
  padding: 45px 0;
} */
.foot_left_img {
  margin: 45px 0;
  float: left;
  display: inline-block;
  background: url('../../assets/code_img.png');
  width: 90px;
  height: 90px;
}
.foot_right {
  color: #ffffff;
  box-sizing: border-box;
  width: 60%;
  float: right;
  text-align: right;
}
  .beian_mark{
    text-decoration:none;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/foot.vue